/** German plan marketing metadata. */
export const PLAN_MARKETING = {
  free: {
    audience: 'Für Einsteiger, die Marktbewegungen verstehen wollen — ohne Kosten.',
    popular: false,
    ctaLabel: 'Kostenlos starten',
  },
  core: {
    audience: 'Für aktive Trader mit 10 Ticker und täglichem Marktbezug.',
    popular: false,
    ctaLabel: 'Core wählen',
  },
  pro: {
    audience: 'Für Trader, die volle Analyse-Tiefe und AI-Brain brauchen.',
    popular: true,
    ctaLabel: 'Pro wählen',
  },
  terminal: {
    audience: 'Für Power-User, Teams und professionelle Workflows.',
    popular: false,
    ctaLabel: 'Terminal wählen',
  },
};

export function getPlanMarketing(tier) {
  return PLAN_MARKETING[tier] ?? { audience: '', popular: false, ctaLabel: 'Plan wählen' };
}
